var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ubication",
    transform: "translate(-145 -492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_212",
    "data-name": "Elipse 212",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(145 492)",
    fill: "#A6192E",
    opacity: 0.382
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_213",
    "data-name": "Elipse 213",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(156 503)",
    fill: "#A6192E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerUser);
export default __webpack_public_path__ + "static/media/marker_user.375fe4dfce62bbbd676796a9ae4a6de3.svg";
export { ForwardRef as ReactComponent };